

export const fieldTypes = [
    { id: 'label', label: 'Label' },
    { id: 'text', label: 'Text Field' },
    { id: 'number', label: 'Number Field' },
    { id: 'email', label: 'Email Field' },
    { id: 'date', label: 'Date Picker' },
    { id: 'select', label: 'Dropdown' },
    // { id: 'checkbox', label: 'Checkbox' },
    // { id: 'radio', label: 'Radio Button' },
    { id: 'file', label: 'File Upload' },
    { id: 'textarea', label: 'Text Area' },
    { id: 'programme-selector', label: 'Programme Selector' },
];
export const fieldTypesOLd = [
    { id: 'label', label: 'Label' },
    { id: 'text', label: 'Text Field' },
    { id: 'number', label: 'Number Field' },
    { id: 'email', label: 'Email Field' },
    { id: 'date', label: 'Date Picker' },
    { id: 'select', label: 'Dropdown' },
    { id: 'checkbox', label: 'Checkbox' },
    { id: 'radio', label: 'Radio Button' },
    { id: 'file', label: 'File Upload' },
    { id: 'textarea', label: 'Text Area' },
    { id: 'programme-selector', label: 'Programme Selector' },
];

export const formTemplates = {
    undergraduate: [
        { 
            id: 'section1', 
            name: 'BASIC INFORMATION', 
            fields: [
                {
                    id: 'full-name',
                    type: 'text',
                    label: 'Full Name',
                    required: true,
                    locked: true
                },
                {
                    id: 'date-of-birth',
                    type: 'date',
                    label: 'Date of Birth',
                    required: true,
                    locked: true
                },
                {
                    id: 'gender',
                    type: 'select',
                    label: 'Gender',
                    required: true,
                    options: ['Male', 'Female', 'Other'],
                    locked: true
                },
                {
                    id: 'email',
                    type: 'email',
                    label: 'Email Address',
                    required: true,
                    locked: true
                },
                {
                    id: 'contact-number',
                    type: 'text',
                    label: 'Contact Number',
                    required: true,
                    locked: true
                }
            ] 
        },
    ],
    graduate: [
        { 
            id: 'section1', 
            name: 'BASIC INFORMATION', 
            fields: [
                {
                    id: 'full-name',
                    type: 'text',
                    label: 'Full Name',
                    required: true,
                    locked: true
                },
                {
                    id: 'date-of-birth',
                    type: 'date',
                    label: 'Date of Birth',
                    required: true,
                    locked: true
                },
                {
                    id: 'gender',
                    type: 'select',
                    label: 'Gender',
                    required: true,
                    options: ['Male', 'Female', 'Other'],
                    locked: true
                },
                {
                    id: 'email',
                    type: 'email',
                    label: 'Email Address',
                    required: true,
                    locked: true
                },
                {
                    id: 'contact-number',
                    type: 'text',
                    label: 'Contact Number',
                    required: true,
                    locked: true
                }
            ] 
        },
    ],
    shortcourse: [
        { 
            id: 'section1', 
            name: 'BASIC INFORMATION', 
            fields: [
                {
                    id: 'full-name',
                    type: 'text',
                    label: 'Full Name',
                    required: true,
                    locked: true
                },
                {
                    id: 'nationality',
                    type: 'text',
                    label: 'Nationality',
                    required: true,
                    locked: true
                },
                {
                    id: 'date-of-birth',
                    type: 'date',
                    label: 'Date of Birth',
                    required: true,
                    locked: true
                },
                {
                    id: 'gender',
                    type: 'select',
                    label: 'Gender',
                    required: true,
                    options: ['Male', 'Female', 'Other'],
                    locked: true
                },
                {
                    id: 'email',
                    type: 'email',
                    label: 'Email Address',
                    required: true,
                    locked: true
                },
                {
                    id: 'contact-number',
                    type: 'text',
                    label: 'Contact Number',
                    required: true,
                    locked: true
                }
            ] 
        },
    ],
};
